/* eslint-disable no-console */
import Contactos from '../../api/Contactos';
import BasicNotification from '../../shared/components/Notifications/BasicNotification';
import { contactTypes } from '../types/contact.types';

export const createContacts = (data, cb) => async (dispatch) => {
  dispatch({ type: contactTypes.CREATE_CONTACTS });
  try {
    BasicNotification.info('Creando contacto...');
    const { body } = await Contactos.create(data);
    if (cb) {
      cb(body);
    }
    dispatch({ type: contactTypes.CREATE_CONTACTS_SUCCESS, payload: { contacts: body } });
    BasicNotification.success('Contacto creado con éxito.');
  } catch (error) {
    console.error(error);
    if (error.status === 409 && error.response.body.code === 'EmailAlreadyExists') {
      BasicNotification.error('El email ingresado ya está registrado en el sistema.');
    } else if (error.status === 409 && error.response.body.code === 'RUTAlreadyExists') {
      BasicNotification.error('El rut ingresado ya está registrado en el sistema.');
    } else {
      BasicNotification.error('Ocurrió un error al intentar crear el usuario');
    }
    dispatch({ type: contactTypes.CREATE_CONTACTS_FAILED, error });
  }
};

export const generatePass = (data, cb) => async (dispatch) => {
  dispatch({ type: contactTypes.GENERATE_PASS });
  try {
    const { body, status } = await Contactos.generatePass(data);
    if (cb) cb(body, status);
    dispatch({ type: contactTypes.GENERATE_PASS_SUCCESS, payload: body.password || '' });
  } catch (error) {
    if (cb) cb(error?.response?.body || null, error?.response?.status || 500);
    if (error) {
      BasicNotification.error('Usuario no encontrado');
    }
    dispatch({ type: contactTypes.GENERATE_PASS_FAILED, error: JSON.stringify(error) });
  }
};

export const getContacts = (query = {}, cb = null) => async (dispatch) => {
  dispatch({ type: contactTypes.GET_CONTACTS, cargando: true });
  try {
    const { body, header } = await Contactos.get(query);
    const count = header['x-pagination-total-count'];
    const limit = header['x-pagination-limit'];
    if (cb) {
      cb(body);
    }
    dispatch({ type: contactTypes.GET_CONTACTS_SUCCESS, payload: { contacts: body, count, limit } });
  } catch (error) {
    dispatch({ type: contactTypes.GET_CONTACTS_FAILED, cargando: false, payload: { error } });
    console.error(error);
    BasicNotification.error('Ocurrió un error al intentar obtener los usuarios');
  }
};

export const getContactById = (id, cb) => async (dispatch) => {
  dispatch({ type: contactTypes.GET_CONTACT_ID, cargando: true });
  try {
    const { body } = await Contactos.getById(id);

    if (cb) {
      cb(body.contact);
    }
    dispatch({ type: contactTypes.GET_CONTACT_ID_SUCCESS, cargando: false, payload: { contact: body.contact } });
  } catch (error) {
    console.error(error);
    if (error.status === 404) {
      BasicNotification.error('El contacto no está registrado en el sistema.');
    } else {
      BasicNotification.error('Ocurrió un error al intentar obtener el usuario');
    }
    dispatch({ type: contactTypes.GET_CONTACT_ID_FAILED, cargando: false, payload: { error } });
  }
};

export const getContactByRut = (rut, cb) => async (dispatch) => {
  dispatch({ type: contactTypes.GET_CONTACT_RUT });
  try {
    const { body, status } = await Contactos.getByRut(rut);
    if (cb) {
      cb(body, status);
    }
    dispatch({ type: contactTypes.GET_CONTACT_RUT_SUCCESS, payload: { contact: body } });
  } catch (error) {
    if (error.status === 404) {
      BasicNotification.error('El contacto no está registrado en el sistema.');
      if (cb) {
        cb(404);
      }
    } else if (error.status === 400 && error.response.body.code === 'ErrorTrinidad') {
      BasicNotification.error('Error en servicio externo.');
    } else {
      BasicNotification.error('Ocurrió un error al intentar obtener el cliente');
    }
    dispatch({ type: contactTypes.GET_CONTACT_RUT_FAILED, payload: { error }, });
  }
};

export const getContractByRut = rut => async (dispatch) => {
  dispatch({ type: contactTypes.GET_CONTRACT_BY_RUT });
  try {
    const { body } = await Contactos.getContractByRut(rut);
    dispatch({
      type: contactTypes.GET_CONTRACT_BY_RUT_SUCCESS,
      payload: { contracts: body },
    });
  } catch (error) {
    console.error(error);
    if (error.status === 404) {
      BasicNotification.error('El contacto no está registrado en el sistema.');
    } else if (error.status === 400 && error.response.body.code === 'ErrorTrinidad') {
      BasicNotification.error('Error en servicio externo.');
    } else {
      BasicNotification.error('Ocurrió un error al intentar obtener el usuario');
    }
    dispatch({
      type: contactTypes.GET_CONTRACT_BY_RUT_FAILED,
      payload: { error },
    });
  }
};

export const updateContact = (id, data, cb) => async (dispatch) => {
  BasicNotification.info('Actualizando usuario...');
  dispatch({ type: contactTypes.UPDATE_CONTACT });
  try {
    const { body } = await Contactos.update(id, data);
    dispatch({ type: contactTypes.UPDATE_CONTACT_SUCCESS, payload: { body } });
    if (cb) {
      cb(body);
    }
    BasicNotification.success('Usuario actualizado con éxito.');
  } catch (error) {
    console.error(error);
    dispatch({ type: contactTypes.UPDATE_CONTACT_FAILED, payload: { error } });
    if (error.status === 409 && error.response.body.code === 'EmailAlreadyExists') {
      BasicNotification.error('El email ingresado ya está registrado en el sistema.');
    } else {
      BasicNotification.error('Ocurrió un error al intentar actualizar el usuario');
    }
  }
};

export const getContactData = (rut, cb) => async (dispatch) => {
  dispatch({ type: contactTypes.GET_CONTACT_DATA });
  try {
    const { body, status } = await Contactos.getContactData(rut);
    dispatch({
      type: contactTypes.GET_CONTACT_DATA_SUCCESS,
      payload: { body },
    });
    if (cb) cb(body, status);
  } catch (error) {
    console.log(error.status);
    if (cb) cb(error.response?.body || null, error?.status || 500);
    if (error.status === 404) {
      BasicNotification.error('Contacto no encontrado en Portal Clientes.');
    } else if (error.status === 400 && error.response.body.code === 'ErrorTrinidad') {
      BasicNotification.error('Error en servicio externo.');
    } else {
      BasicNotification.error('Ocurrió un error al intentar obtener el usuario');
    }
    dispatch({
      type: contactTypes.GET_CONTACT_DATA_FAILED,
      payload: { error },
    });
  }
};

export const updateContactData = (rut, data, cb) => async (dispatch) => {
  BasicNotification.info('Actualizando contacto...');
  dispatch({ type: contactTypes.UPDATE_CONTACT_DATA });
  try {
    const { body } = await Contactos.updateContactData(rut, data);
    dispatch({ type: contactTypes.UPDATE_CONTACT_DATA_SUCCESS, payload: { body } });

    if (cb) {
      cb(body);
    }
    BasicNotification.success('Contacto actualizado con éxito.');
  } catch (error) {
    dispatch({ type: contactTypes.UPDATE_CONTACT_DATA_FAILED, payload: { error } });
    BasicNotification.error('Ocurrió un error al intentar actualizar el contacto');
  }
};

export const deleteUser = (id, cb) => async (dispatch) => {
  dispatch({ type: contactTypes.DELETE_CONTACTS });
  BasicNotification.info('Eliminado usuario...');
  try {
    await Contactos.removeById(id);
    if (cb) {
      cb();
    }
    dispatch({ type: contactTypes.DELETE_CONTACTS_SUCCESS });
    BasicNotification.success('Usuario eliminado con éxito.');
  } catch (error) {
    dispatch({ type: contactTypes.DELETE_CONTACTS_FAILED });
    console.error(error);
    if (error.status === 409 && error.response.body.code === 'ContactNotDeleted') {
      BasicNotification.error('El cliente no se puede eliminado porque esta asociado a una operación.');
    } else {
      BasicNotification.error('Ocurrió un error al intentar eliminar el usuario');
    }
  }
};

export const resetState = () => (dispatch) => {
  dispatch({ type: contactTypes.RESET_CONTACT_STATE });
};

export const resetContactData = () => (dispatch) => {
  dispatch({ type: contactTypes.RESET_CONTACT_DATA });
};

export const resetContact = () => (dispatch) => {
  dispatch({ type: contactTypes.RESET_CONTACT });
};
